<script lang="ts">

const SortOrderEnum =
{
  Asc: 0,
  Desc: 1,
}

export default SortOrderEnum;

</script>